import type { Theme } from '$lib/types';
import { ThemeId, ThemeKind } from '$lib/enums';

export const THEMES: readonly Theme[] = [
	{ id: ThemeId.LIGHT, kind: ThemeKind.LIGHT, classNames: [ThemeId.LIGHT, 'prism-light'] },
	{ id: ThemeId.SILVER, kind: ThemeKind.LIGHT, classNames: [ThemeId.SILVER, 'prism-light'] },
	{
		id: ThemeId.SOLARIZED_LIGHT,
		kind: ThemeKind.LIGHT,
		classNames: [ThemeId.SOLARIZED_LIGHT, 'prism-light']
	},
	{ id: ThemeId.LATTE, kind: ThemeKind.LIGHT, classNames: [ThemeId.LATTE, 'prism-light'] },
	{ id: ThemeId.DARK, kind: ThemeKind.DARK, classNames: [ThemeId.DARK, 'prism-dark'] },
	{ id: ThemeId.BUTTER, kind: ThemeKind.DARK, classNames: [ThemeId.BUTTER, 'prism-dark'] },
	{ id: ThemeId.CARBON, kind: ThemeKind.DARK, classNames: [ThemeId.CARBON, 'prism-dark'] },
	{ id: ThemeId.NORD, kind: ThemeKind.DARK, classNames: [ThemeId.NORD, 'prism-dark'] },
	{ id: ThemeId.DRACULA, kind: ThemeKind.DARK, classNames: [ThemeId.DRACULA, 'prism-dark'] },
	{ id: ThemeId.GRUVBOX, kind: ThemeKind.DARK, classNames: [ThemeId.GRUVBOX, 'prism-dark'] },
	{ id: ThemeId.CATPPUCCIN, kind: ThemeKind.DARK, classNames: [ThemeId.CATPPUCCIN, 'prism-dark'] },
	{
		id: ThemeId.TOKYO_NIGHT,
		kind: ThemeKind.DARK,
		classNames: [ThemeId.TOKYO_NIGHT, 'prism-dark']
	},
	{ id: ThemeId.ROSE_PINE, kind: ThemeKind.DARK, classNames: [ThemeId.ROSE_PINE, 'prism-dark'] },
	{
		id: ThemeId.SOLARIZED_DARK,
		kind: ThemeKind.DARK,
		classNames: [ThemeId.SOLARIZED_DARK, 'prism-dark']
	}
];

export const THEME_NAMES: Record<ThemeId, string> = {
	[ThemeId.LIGHT]: 'Light',
	[ThemeId.SILVER]: 'Silver',
	[ThemeId.SOLARIZED_LIGHT]: 'Solarized Light',
	[ThemeId.LATTE]: 'Catppuccin Latte',
	[ThemeId.DARK]: 'Dark',
	[ThemeId.BUTTER]: 'Butter',
	[ThemeId.CARBON]: 'Carbon',
	[ThemeId.NORD]: 'Nord',
	[ThemeId.DRACULA]: 'Dracula',
	[ThemeId.GRUVBOX]: 'Gruvbox',
	[ThemeId.CATPPUCCIN]: 'Catppuccin Mocha',
	[ThemeId.TOKYO_NIGHT]: 'Tokyo Night',
	[ThemeId.ROSE_PINE]: 'Rosé Pine',
	[ThemeId.SOLARIZED_DARK]: 'Solarized Dark'
};

export const DARK_MODE_MEDIA_QUERY = '(prefers-color-scheme: dark)';

export const EMOJI_FONT_PROPERTY = '--font-emoji';

/** Bundled Twemoji ahead of the system emoji stack that `:root` already falls back to. */
export const TWITTER_EMOJI_FONT_STACK = 'Twemoji, var(--font-emoji-system)';
